globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.LocalManagement = appCustomerSpace.Modals.LocalManagement || {};

appCustomerSpace.Modals.LocalManagement.AddServiceAreaCity = (function(superClass) {

  utils.extend(AddServiceAreaCity, superClass);

  function AddServiceAreaCity() {
    return AddServiceAreaCity.__super__.constructor.apply(this, arguments);
  }

  $.extend(AddServiceAreaCity.prototype, {
    init: function() {
      var modal = this;

      appCustomerSpace.LimitlessPlugins.Tooltip.init(this.$html);

      var $modal = $('.modal'),
          $searchInput = $modal.find('.input-filter'),
          debounceTimeout;

      function searchCities(query) {
        var errorMsg = 'Erreur de chargement';

        if (query.trim() !== "" && query.length > 2) {

          appCustomerSpace.Loader().start({ $container: $modal.find('.media-list'), options: {text: false} });

          $.ajax({
            type: "GET",
            url: $searchInput.data('ajax-url'),
            data: {request: query},
            success: function(data) {
              if (data.response == 1) {
                $modal.find('.media-list').html(data.html).end().find('.other-city').show();
                $modal.find('.search-cities-message').hide();
              } else {
                alert(errorMsg);
              }
            }
          }).fail(function() {
            alert(errorMsg);
          });
        } else {
          $modal.find('.media.other-city').remove().end().find('.search-cities-message').show();
        }
      }

      $searchInput.on('keyup', function() {
        var query = $(this).val();

        clearTimeout(debounceTimeout);

        debounceTimeout = setTimeout(function(){
          searchCities(query)
        }, 500);
      });

      $modal.on('click', '.media-link', function(e) {
        e.preventDefault();

        var $container = $(this),
            selectedCityId = $container.data('city-id'),
            selectedCityLabel = $container.find('.city-label').text();

        appCustomerSpace.Loader().start({ $container: $container });

        var $serviceAreaCitiesContainer = $('.service-area-cities-container'),
            $formGroups = $serviceAreaCitiesContainer.find('.form-group'),
            $firstFormGroup = $formGroups.first(),
            $firstDestroyInput = $firstFormGroup.find('.secondary-service-area-city-destroy-input');

        if ($firstFormGroup.find('input.service-area-city-id-input').val() != "") {
          var $newFormGroup = $formGroups.last().clone(),
              label = $newFormGroup.data('label');

          $newFormGroup.find('input.store-service-area-city-id').val(selectedCityId).end()
            .find('input.service-area-city-input').val(selectedCityLabel).end()
            .find('.service-area-city-destroy-input').val(false).end()
            .appendTo($serviceAreaCitiesContainer).end().show();

          var index = new Date($.now()).getTime();
          $newFormGroup.find('input').each(function () {
            var $input = $(this);
            var inputName = $input.attr('name');

            if (inputName != undefined) {
              var newName = inputName.replace(/(\[\d*\])/, '[' + index + ']');
              $input.attr('name', newName);
            }
          })
        } else {
          $serviceAreaCitiesContainer.find('p').hide();
          $firstFormGroup.parent().show().end()
            .find('input.service-area-city-id-input').val(selectedCityId).end()
            .find('input.service-area-city-label-input').val(selectedCityLabel);
          $firstDestroyInput.val(false);
        }

        if ($formGroups.length > 9 ) {
          $serviceAreaCitiesContainer.find('.cities-count-alert').show();
          $serviceAreaCitiesContainer.find('#cities-count-number').text($formGroups.length + 1);
        }

        modal.close();
        appCustomerSpace.Loader().stop({ $container: $container });
      });

      return AddServiceAreaCity.__super__.init.apply(this, arguments);
    }
  });

  return AddServiceAreaCity;

})(appCustomerSpace.Modal);
